import { Size } from '@Components/designConstants';
import { SegmentedControlButton } from '@Components/SegmentedControlButton';
import { GoalView, GoalViewType } from './goal-intake-edit-utils';

const VIEW_OPTIONS = Object.values(GoalView);

interface GoalIntakeViewToggleProps {
  view: GoalViewType;
  onChange: (view: GoalViewType) => void;
}

export const GoalIntakeViewToggle = ({ view, onChange }: GoalIntakeViewToggleProps) => (
  <SegmentedControlButton
    size={Size.LG}
    options={VIEW_OPTIONS}
    selectedOption={view}
    onChange={onChange}
  />
);
